const ALLOWED_COOKIE_KEYS = ['_fbc', '_fbp', '_ga', 'li_fat_id', 'tid'] as const;

function parseCookieString(cookieStr: string): Record<string, string> {
  if (!cookieStr) return {};

  const result: Record<string, string> = {};

  for (const pair of cookieStr.split(';')) {
    const idx = pair.indexOf('=');

    if (idx === -1) continue;

    const key = pair.slice(0, idx).trim();
    const rawValue = pair.slice(idx + 1).trim();

    if (!key) continue;

    try {
      result[key] = decodeURIComponent(rawValue);
    } catch {
      result[key] = rawValue;
    }
  }

  return result;
}

export function filterAllowedCookies(cookies: Record<string, string>): Record<string, string> {
  const result: Record<string, string> = {};

  for (const key of ALLOWED_COOKIE_KEYS) {
    if (cookies[key] !== undefined) {
      result[key] = cookies[key];
    }
  }

  return result;
}

export function allowlistedCookies(cookieStr: string): Record<string, string> {
  const parsedCookies = parseCookieString(cookieStr);

  return filterAllowedCookies(parsedCookies);
}
